class DLPageSaasFaqH extends HTMLElement {
  constructor() {
    super();
    this.items = [];
  }

  connectedCallback() {
    this.init();
    this.handleResize();
  }

  init() {
    this.items = Array.from(this.querySelectorAll('.dl-page-saas-faq-h-content-item'));
    this.content = this.querySelector('.dl-page-saas-faq-h-content');
    this.toggleBtn = this.querySelector('.dl-page-saas-faq-h-content-toggle-btn');

    this.items.forEach(item => {
      const titleElement = item.querySelector('.dl-page-saas-faq-h-content-item-title');
      if (titleElement) {
        titleElement.addEventListener('click', () => this.handleItemClick(item));
      }
    });

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.handleToggleClick());
    }

    if (this.items.length > 0) {
      this.expandItem(this.items[0]);
    }
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.recalculateExpandedItemsHeight();
      }, 150);
    });
  }

  handleItemClick(clickedItem) {
    const isExpanded = clickedItem.dataset.expanded === 'true';

    if (isExpanded) {
      this.collapseItem(clickedItem);
    } else {
      this.expandItem(clickedItem);
    }
  }

  handleToggleClick() {
    if (!this.content) return;

    const isAllVisible = this.content.dataset.allVisible === 'true';

    if (isAllVisible) {
      this.collapseExtraItems();
      this.content.dataset.allVisible = 'false';
    } else {
      this.content.dataset.allVisible = 'true';
      this.expandExtraItems();
    }
  }

  expandExtraItems() {
    this.items.forEach((item, index) => {
      if (index >= 5) {
        const currentTransition = item.style.transition;
        item.style.transition = 'none';
        item.style.maxHeight = 'none';
        
        const height = item.scrollHeight;
        
        item.style.maxHeight = '0';
        
        item.offsetHeight;
        
        item.style.transition = currentTransition;
        
        item.style.maxHeight = height + 'px';

        setTimeout(() => {
          if (this.content && this.content.dataset.allVisible === 'true') {
            item.style.maxHeight = 'none';
          }
        }, 500);
      }
    });
  }

  collapseExtraItems() {
    this.items.forEach((item, index) => {
      if (index >= 5) {
        const currentHeight = item.scrollHeight;
        item.style.maxHeight = currentHeight + 'px';
        
        item.offsetHeight;
        
        item.style.maxHeight = '0';
      }
    });
  }

  expandItem(item) {
    const desc = item.querySelector('.dl-page-saas-faq-h-content-item-desc');
    if (!desc) return;

    item.dataset.expanded = 'true';

    const height = desc.scrollHeight;

    desc.style.maxHeight = height + 'px';
  }

  collapseItem(item) {
    const desc = item.querySelector('.dl-page-saas-faq-h-content-item-desc');
    if (!desc) return;

    item.dataset.expanded = 'false';

    desc.style.maxHeight = '0';
  }

  recalculateExpandedItemsHeight() {
    this.items.forEach(item => {
      if (item.dataset.expanded === 'true') {
        const desc = item.querySelector('.dl-page-saas-faq-h-content-item-desc');
        if (desc) {
          desc.style.transition = 'none';
          desc.style.maxHeight = 'none';
          const newHeight = desc.scrollHeight;
          desc.style.maxHeight = newHeight + 'px';

          desc.offsetHeight;
          desc.style.transition = '';
        }
      }
    });

    if (this.content && this.content.dataset.allVisible === 'true') {
      this.items.forEach((item, index) => {
        if (index >= 5 && item.style.maxHeight !== 'none') {
          item.style.maxHeight = 'none';
        }
      });
    }
  }
}

customElements.define('dl-page-saas-faq-h', DLPageSaasFaqH);

